import styles from "./News.module.css"
import CloseButton from "../../Button/CloseButton/CloseButton";
import slaviaSrc from "../../../assets/images/news/slavia/photo.jpg"
import slaviaTitleSrc from "../../../assets/images/news/slavia/title.png"
import textTitleSrc1 from "../../../assets/images/news/slavia/title2.png"
import { handleBackgroundScroll } from "../../../utils/backgroundScroll";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { CmsAktualita } from "../../../types/cms.types";
import { pickCmsText, splitParagraphs } from "../../../utils/cmsText";
/**
* Props for the NewsPopup component.
*/
interface NewsProps{
    onClose?: ()=>void, // Close popup handler
    display?: boolean, // Whether to display
    className?:string, // Optional additional class
    cardClassName?:string // Optional additional card class
    aktualita?: CmsAktualita // CMS article to show; without it the built-in article renders
}
/**
* A news popup component.
* Renders the CMS aktualita it receives, or the built-in article as fallback.
*
* @param props NewsProps
* @param {() => void} props.onClose - Close popup handler
* @param {boolean} props.display - Whether to display
* @param {string} props.className - Optional additional class
* @param {string} props.cardClassName - Optional additional card class
* @param {CmsAktualita} props.aktualita - CMS article to show
* @returns TSX.Element
*/
const NewsPopup = ({onClose,  cardClassName, display = false, className, aktualita}:NewsProps) => {
    const { i18n } = useTranslation();
    // Stop scroll on open
    useEffect(()=>{
        handleBackgroundScroll(display)
    }, [display])

    const title = pickCmsText(aktualita?.title, i18n.language, "");
    const body = pickCmsText(aktualita?.body, i18n.language, "");

    return(
        <>
        <div className={`${display ? styles.Popup : styles.PopupHidden} ${className || ''}`}>
            <div className={styles.PopupBg} onClick={onClose}></div>
            <div className={`${styles.PopupCard} ${cardClassName || ''}`}>
                <CloseButton onClick={onClose ?? (() => {})} className={styles.ClosePopup}/>
                {aktualita ? (
                    <>
                        <p className={styles.PopupTitle}>{title}</p>
                        {aktualita.imageUrl && (
                            <div className={styles.NewsHeader}>
                                <img className={styles.NewsHeaderPhoto} src={aktualita.imageUrl} alt={title} />
                            </div>
                        )}
                        {splitParagraphs(body).map((paragraph, index) => (
                            <p key={index} className={styles.BaseText}>{paragraph}</p>
                        ))}
                    </>
                ) : (
                    <>
                        <p className={styles.PopupTitle}>Loděnice VK Slavia: Stylový prostor s atmosférou</p>
                        <div className={styles.NewsHeader}>
                            <img className={styles.NewsHeaderPhoto} src={slaviaSrc} alt="" />
                            <img  className={styles.NewsHeaderTitle} src={slaviaTitleSrc} alt="" />
                        </div>
                        <p className={styles.BaseText}>
                            Chcete pro Vaši firmu zajistit neobyčejný zážitek? Nabízíme Vám možnost uspořádat Vaši firemní akci v malebném prostředí loděnice VK Slavia Praha. Tento unikátní prostor s nezaměnitelnou atmosférou je ideální pro události jakéhokoli rozsahu. Ať už si přejete BBQ, exkluzivní degustaci šampaňského, nebo třeba kreativní workshop s obědem, loděnice nabízí flexibilní zázemí. Navíc, pronájmem prostoru přímo podpoříte novou generaci veslařů VK Slavia Praha!
                        </p>
                        <img className={styles.TitlePhoto} src={textTitleSrc1} alt="" />
                        <p className={styles.BaseText}>
                            Ať už plánujete firemní večírek, teambuilding, školení, nebo jakoukoli jinou firemní akci, naše cateringové služby v kombinaci s unikátním prostorem loděnice VK Slavia Praha jsou ideální volbou. Jsme schopni připravit cokoliv na míru dle Vašich požadavků – od menu, přes program, až po celkovou atmosféru. S námi bude Vaše akce nejen o skvělém jídle a pití, ale především o nezapomenutelném zážitku pro všechny účastníky.
                        </p>
                        <img className={styles.TitlePhoto} src={textTitleSrc1} alt="" />
                        <p className={styles.BaseText}>
                            Neváhejte a pošlete nám poptávku nebo nás kontaktujte pro více informací a vytvoření nabídky na míru: catermat@catermat.com nebo +420 222 510 446.<br/>
                            Společně pro vaši firmu uspořádáme akci, na kterou budou vaši kolegové ještě dlouho vzpomínat!
                        </p>
                    </>
                )}
            </div>
        </div>
        </>
    )
};

export default NewsPopup;
